import React from 'react';

import cx from 'classnames';
import { Drawer } from 'antd';
import Icon from '@ant-design/icons';

import { ReactComponent as CrossSVG } from '../../../../assets/sightx-icons/svg/x-close.svg';

import styles from './index.module.scss';

export interface ICreditsPoolOverview {
  title: string;
  onClose?: () => void;
  className?: string;
}

const DrawerBase: React.FC<ICreditsPoolOverview> = ({ children, title, onClose = () => true, className: classNameExternal }) => {

  return (
    <Drawer
      width={567}
      title={<div className={styles.title}>{title}</div>}
      placement="right"
      closable
      closeIcon={<Icon className={styles.closeIcon} component={CrossSVG} />}
      onClose={onClose}
      visible
      getContainer={false}
      maskClosable={false}
      keyboard={false}
      className={cx(styles.drawer, classNameExternal)}
    >
      {children}
    </Drawer>
  );

};

export { DrawerBase };
